import { useI18n } from 'hooks/useI18n';
import { UIOfferRanges } from 'interfaces/ui/ui-offer-when-schedule';
import {
  StyledWhenInfographic,
  StyledWhenInfographicBlock,
  StyledWhenInfographicItem,
  StyledWhenInfographicItemExtra,
  StyledWhenInfographicItemLabel,
  StyledWhenInfographicItemValue,
  StyledWhenInfographicTitle
} from './WhenInfographicMobile.styled';

type WhenInfographicMobileProps = {
  ranges: UIOfferRanges[];
  title: string;
  subtitle?: string;
};

const WhenInfographicMobile = ({
  ranges,
  title,
  subtitle
}: WhenInfographicMobileProps) => {
  const { t } = useI18n('job-offer');

  function getSchedule(
    flexible: boolean | undefined,
    free: boolean | undefined
  ): string {
    if (flexible) {
      return 'flexible';
    } else if (free) {
      return 'free';
    } else {
      return '';
    }
  }

  return (
    <StyledWhenInfographic>
      <StyledWhenInfographicTitle>{title} </StyledWhenInfographicTitle>
      {ranges &&
        ranges.map((range: UIOfferRanges, i: number) => (
          <StyledWhenInfographicBlock key={i}>
            {i === 0 && range.flexibleTime && (
              <StyledWhenInfographicItem
                schedule={getSchedule(range.flexibleTime, range.freeTime)}
              >
                <StyledWhenInfographicItemLabel>
                  {t('when.schedules.flexIn')}
                </StyledWhenInfographicItemLabel>
                <StyledWhenInfographicItemValue>
                  {range.startTime}
                  <span className="separator"> - </span>
                  {range.endTime}
                </StyledWhenInfographicItemValue>
              </StyledWhenInfographicItem>
            )}
            {!range.freeTime &&
              ((range.flexibleTime && i > 1) || !range.flexibleTime) &&
              ((range.flexibleTime && i < ranges.length - 1) ||
                !range.flexibleTime) && (
                <StyledWhenInfographicItem
                  schedule={getSchedule(range.flexibleTime, range.freeTime)}
                >
                  {(i === 0 || i === 1) && (
                    <StyledWhenInfographicItemLabel>
                      {subtitle}
                    </StyledWhenInfographicItemLabel>
                  )}
                  <StyledWhenInfographicItemValue>
                    {range.startTime}
                    <span className="separator"> - </span>
                    {range.endTime}
                  </StyledWhenInfographicItemValue>
                </StyledWhenInfographicItem>
              )}
            {range.freeTime && (
              <StyledWhenInfographicItem
                schedule={getSchedule(range.flexibleTime, range.freeTime)}
              >
                <StyledWhenInfographicItemExtra>
                  {t('when.schedules.freeTimeMobile', {
                    total:
                      range.totalTime < 1
                        ? `${range.totalTime * 60}${t('when.minutes')}`
                        : `${range.totalTime}${t('when.hours')}`,
                    start: range.startTime,
                    end: range.endTime
                  })}
                </StyledWhenInfographicItemExtra>
              </StyledWhenInfographicItem>
            )}
            {i === ranges.length - 1 && range.flexibleTime && (
              <StyledWhenInfographicItem
                schedule={getSchedule(range.flexibleTime, range.freeTime)}
              >
                <StyledWhenInfographicItemLabel>
                  {t('when.schedules.flexOut')}
                </StyledWhenInfographicItemLabel>
                <StyledWhenInfographicItemValue>
                  {range.startTime}
                  <span className="separator"> - </span>
                  {range.endTime}
                </StyledWhenInfographicItemValue>
              </StyledWhenInfographicItem>
            )}
          </StyledWhenInfographicBlock>
        ))}
    </StyledWhenInfographic>
  );
};

export default WhenInfographicMobile;
